import { useContext } from "react";
import { ProjectContext } from "../contexts/ProjectContext";

function useInitialize() {
  const {setElement, setShowModal} = useContext(ProjectContext);
  return () => {
    setElement({});
    setShowModal(true);
  }
}

export default useInitialize;